import BaseEntity        from "@/core/misc/BaseEntity";
import VehicleType       from "@/domains/VehicleTypes/VehicleType";
import IntRange          from "@/core/types/IntRange";
import Core              from "@/core/Core";
import UnitsService      from "@/domains/Units/UnitsService"
import Title_ru_RU       from "@/core/misc/decorators/Title_ru_RU";
import TYPES             from "@/core/services/Changelogs/types";
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";
import Volume            from "@/core/types/Volume";
import Weight            from "@/core/types/Weight";

@Title_ru_RU_Class('Транспорт')                     // vehicle → Vehicle
class Vehicle extends BaseEntity {
	static Events = {
		Created: 'vehicle:created',
		Updated: 'vehicle:updated',
		Deleted: 'vehicle:deleted',
	} as const;

	/** наименование */
	@Title_ru_RU('Название', TYPES.STRING)
	public name: string;

	/** тип транспорта */
	@Title_ru_RU('Тип транспорта', TYPES.OBJECT)
	public vehicleType: VehicleType;

	/** Температурный режим транспорта */
	@Title_ru_RU('Температурный режим', TYPES.OBJECT)
	public temperatureRange: IntRange;

	/** Максимальный объём кузова (м³) */
	@Title_ru_RU('Максимальный объём кузова (м³)', TYPES.NUMBER)
	public maxVolume: Volume | null = null;

	/** Максимальная грузоподъёмность (кг) */
	@Title_ru_RU('Максимальная грузоподъёмность (кг)', TYPES.NUMBER)
	public maxWeight: Weigh | null = null;

	/** Единица измерения веса (для вида транспорта всегда кг) */
	@Title_ru_RU('Единица измерения веса', TYPES.OBJECT)
	public unit: { id: number; name: string };

  @Title_ru_RU('Количество мест по полу', TYPES.NUMBER)
  public cargoPlacesCount: number | null = null;

  	static fromNew(result = new this()): Vehicle {
    	result.temperatureRange = new IntRange(null, null);
    	result.vehicleType      = new VehicleType();

    	return result;
  	}

	static fromServer(data: any, vehicle = new Vehicle()): Vehicle {
    	super.fromServer(data, vehicle);

    	vehicle.vehicleType      = Core.utils.hydrate(data.vehicleType, Vehicle.fromServer);
    	vehicle.temperatureRange = Core.utils.hydrate(data.temperatureRange, IntRange.fromServer) ?? new IntRange(null, null);
    	vehicle.unit             = UnitsService.units.find(unit => unit.code === '166'); // кг

    	vehicle.maxVolume        = Core.utils.hydrate(data.maxVolume, Volume.fromServer)!;
    	vehicle.maxWeight        = Core.utils.hydrate(data.maxWeight, Weight.fromServer)!;

		return vehicle;
	}

	get nameFull (): string {
		const parts: string[] = [];

		if (this.vehicleType) {
			parts.push(this.vehicleType.name);
		}

		if (this.temperatureRange) {
			parts.push(`${this.temperatureRange.toString()} °C`);
		}

		if (this.maxWeight) {
      parts.push(this.maxWeight.format(this.unit));
		}

		if (this.maxVolume) {
			parts.push(`${this.maxVolume} м³`);
		}

		return parts.join('; ');
	}
}

export default Vehicle;
